import React, { useCallback, useContext } from 'react';
import { i18nContext } from '@/components/pages/assessments/context/i18n.context';
import { displayContext } from '@/components/pages/assessments/context/display.context';

function StepCounter({ step, total, type = 'page_of', lastStepMessage }) {
  const { t } = useContext(i18nContext);
  const { css } = useContext(displayContext);

  // css must define a height, and probably a border
  const progressWrpr = useCallback(
    () => ({
      position: 'relative',
      width: '100%'
    }),
    []
  );

  // css must set a background or something to make the progress visible
  const progressBar = useCallback(
    (width) => ({
      position: 'absolute',
      top: 0,
      left: 0,
      width,
      height: '100%'
    }),
    []
  );

  const width = (step / Math.max(total, 1)) * 100 + '%';

  const useLastPageMessage = () => {
    return step == total && lastStepMessage;
  };

  return (
    <div className={css('step-progress')}>
      {type === 'page_of' && useLastPageMessage() && <>{lastStepMessage}</>}
      {type === 'page_of' && !useLastPageMessage() && t('page_of', { page: step, total })}
      {type === 'progress' && (
        <div style={progressWrpr()} className={css('step-progress-wrpr')}>
          <span style={progressBar(width)}></span>
        </div>
      )}
    </div>
  );
}

export default StepCounter;
